"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
require("./RemoveButton.css");
/**
 * Button to remove a rule.
 */
var RemoveButton = /** @class */ (function (_super) {
    __extends(RemoveButton, _super);
    function RemoveButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RemoveButton.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "gs-rule-removebutton" },
            React.createElement(antd_1.Button, { style: {}, type: "danger", icon: "close-circle-o", size: "large", onClick: function () { return _this.props.onClick(_this.props.ruleIdx); } },
                " ",
                this.props.text)));
    };
    RemoveButton.defaultProps = {
        text: 'Remove Rule'
    };
    return RemoveButton;
}(React.Component));
exports.RemoveButton = RemoveButton;
exports.default = RemoveButton;
//# sourceMappingURL=RemoveButton.js.map